export class AppyUser {
  id: number;
  name: string;
  email: string;
  createDate: Date;
  role: string;
  phoneNumber: string;
  preferredCommunicationMethod: string;
  patientId: number;
  practitionerId: number;
  isImpersonating: boolean;
  confirmedDate: Date;
  confirmedByUserID: number;
  requiresPayment: boolean;
  customerId: string;
  paymentId: string;
  lastSignInDate?: Date;
  isProfileSetUpCompleted: boolean;
  isGlobalAdministrator: boolean;
  managedPractitionerIds: number[];
  userRoleCategory: string;
  isActive: boolean;
  healthOrganizationCreator: boolean;
  isHOAccessActive: boolean;
  IsUnderTrialPeriod: boolean;
  healthOrganizationTypeId :number;
  healthOrganizationId:number;
  authorizeNetUserID : string;
  paymentAuthorizeNetID: string;
  employerId: number;
  response?: {
    isSuccess: boolean
  }

  isAdmin(): boolean {
    if (this.role === 'Administrator' || this.isGlobalAdministrator) {
      return true;
    }
    else {
      return false;
    }
  }

  hasPractitioner() : boolean
  {
    return this.practitionerId >0;
  }

}
